import {domReady} from './Functions/DomReady';
import {mailDecryption} from './Functions/MailDecryption';
import './jquery-global';
import * as $ from 'jquery';
/* javascript */
import '../JavaScript/js-marker-clusterer/src/markerclusterer';
import MapsController from '../../../../rampf_partner/Resources/Public/JavaScript/Classes/MapsController';
import SlimSelect from 'slim-select';


/* TypeScript */
import {NavigationController} from './Controllers/NavigationControllers';
import ProductNavigationController from './Controllers/ProductNavigationControllers';
import TabNavigationController from '../../../../rampf_tabwrapper/Resources/Private/TypeScript/TabNavigationController';
import ProductSelectorController from './Controllers/ProductSelectorController';
import SliderController from './Controllers/SliderController';
import TestimonialController from './Controllers/TestimonialController';
import FilterFormController from './Controllers/Form/FilterFormController';
import DownloadController from './Controllers/DownloadController';
import AjaxController from './Controllers/AjaxController';
import BlogController from './Controllers/BlogController';
import SubmitHelper from './Controllers/Helper/SubmitHelper';
import FocusPointController from './Controllers/FocusPointController';
import NavigationLanguageController from './Controllers/NavigationLanguageController';
import FilterSelectController from './Controllers/Form/FilterSelectController';
import GlossaryJumpToAnchorController from './Controllers/GlossaryJumpToAnchorController';
import AccordionController from '../../../../rampf_accordion/Resources/Private/TypeScript/AccordionController';
import {ConsultantController} from './Controllers/ConsultantController';
import ApplicationTipController from './Controllers/ApplicationTipController';
import RampfHistorySliderController from './Controllers/RampfHistorySliderController';
import JobAdFilterController from './Controllers/JobAdFilterController';
import ContactForm from './Controllers/ContactForm';
import OrderFormController from './Controllers/OrderFormController';
import {initSearchAutoComplete} from './Controllers/AutocompleteController';
import {countCompanyItems} from './Functions/CompanyItemsCount';
import ContactFormController from './Controllers/ContactFormController';
import HotspotController from './Controllers/HotspotController';
import NewsroomController from './Controllers/NewsroomController';
import {initScrollableHeader} from './Functions/ScrollableHeaderUtility';


domReady(() => {
  new NavigationController();
  new ProductNavigationController();
  new ProductSelectorController();
  new SliderController();
  new TestimonialController();
  new NavigationLanguageController();
  new FocusPointController();
  new SubmitHelper();
  new AjaxController();
  new BlogController();
  new GlossaryJumpToAnchorController();
  new AccordionController();
  new ApplicationTipController();
  new ContactForm();
  new ConsultantController();
  new RampfHistorySliderController();
  new JobAdFilterController();
  new OrderFormController();
  new HotspotController();
  initSearchAutoComplete();
  countCompanyItems();
  mailDecryption();
  initScrollableHeader();

  // download center
  if ($('.js-rampf-downloads').length) {
    const filterFormController = new FilterFormController();
    const downloadController = new DownloadController();
    downloadController.init();
    filterFormController.addSignal(
      'beforeShowResults',
      (responseData, $ajaxTarget) => {
        return downloadController.beforeShowResults.call(downloadController, responseData, $ajaxTarget);
      });
  }

  // news and blog filter
  if ($('.js-news-filter-company, .js-news-filter-categories, .js-news-filter-year, .js-blog-filter-categories, .js-slim-select-download').length) {
    new FilterSelectController();
  }

  if ($('.js-tabs').length) {
    new TabNavigationController();
  }

  if ($('.js-newsroom').length) {
    new NewsroomController();
  }

  // Initialize slimSelect.
  document.querySelectorAll('.js-slimSelect').forEach((selectElement) => {
    new SlimSelect({
      select: selectElement,
      showSearch: false,
    });
  });

  // Initialize slimSelect for contactForm.
  const contactFormSelect = document.querySelectorAll('.js-slimSelect-contactForm');
  if (typeof contactFormSelect !== 'undefined' && contactFormSelect.length) {
    new ContactFormController();
  }

  // rampf partner
  if ($('.js-partner-map').length) {
    $('.js-partner-map').each((index, element) => {
      const filterFormController = new FilterFormController();
      const mapsController = new MapsController($(element), {});
      filterFormController.addSignal(
        'validateShowResults',
        (responseData) => {
          return mapsController.validateShowResults.call(mapsController, responseData);
        });
      filterFormController.addSignal(
        'beforeShowResults',
        (responseData, $ajaxTarget) => {
          return mapsController.beforeShowResults.call(mapsController, responseData, $ajaxTarget);
        });
      filterFormController.addSignal(
        'afterShowResults',
        (responseData, $ajaxTarget) => {
          return mapsController.afterShowResults.call(mapsController, responseData, $ajaxTarget);
        });
      filterFormController.addSignal(
        'beforeSetHashFromFilterForm',
        ($filterForm) => {
          return mapsController.beforeSetHashFromFilterForm.call(mapsController, $filterForm);
        });
      filterFormController.addSignal(
        'afterSetFilterFormFromHash',
        ($filterForm) => {
          return mapsController.afterSetFilterFormFromHash.call(mapsController, $filterForm);
        });
      new SlimSelect({
        select: '.js-geo-filter-country-clone',
        showSearch: false,
      });

      new SlimSelect({
        select: '.js-partner-productGroup-clone',
        showSearch: false,
      });

      new SlimSelect({
        select: '.js-partner-productGroupCategory-clone',
        showSearch: false,
      });
    });
  }
});
